// Channel admins get owner-parity for chat/topic/channel/event management.
// Channel deletion is the one exception and is gated separately (only allowed
// for admins when the business has opted in via allowAdminDeleteChannel).
export const canManageChannel = (isOwner, myRole) =>
  isOwner || myRole === "admin";
